import request from '../utils/request'
import { getToken } from '../utils/auth'

export function fetchFloorList(filter) {
  return request({
    url: '/api/floors',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function createFloor(data) {
  return request({
    url: '/api/floors',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function createRoom(data) {
  return request({
    url: '/api/rooms',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}
